export enum FileCategory {
  Leads = 'lead_download',
  ContractDeduplication = 'contract_deduplications',
  ZipSegmentFilter = 'zip_segment_filter',
  OrangeReports = 'orange_reports_input',
  Other = 'other',
  Deletion = 'deletion',
}
